module.exports = __webpack_public_path__ + "3e3e2318c679d3f53f97cc7319faeae3.svg";